import { ArrowRight, Phone } from "lucide-react";
import { SITE } from "@/lib/site";

type Props = {
  title?: string;
  subtitle?: string;
  bookLabel?: string;
  bookHref?: string;
};

export function BottomCta({
  title = "Ready to move freight?",
  subtitle = "Call or book online — a live dispatcher answers around the clock.",
  bookLabel = "Book a Load",
  bookHref = "/contact",
}: Props) {
  return (
    <section className="relative overflow-hidden bg-primary py-20 text-primary-foreground">
      <div className="diag-stripes absolute left-0 top-0 h-2 w-full" />
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-4 lg:flex-row lg:items-center lg:px-8">
        <div className="max-w-2xl">
          <h2 className="font-display text-4xl leading-[0.95] md:text-5xl lg:text-6xl">{title}</h2>
          <p className="mt-4 text-lg text-primary-foreground/90">{subtitle}</p>
        </div>
        <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
          <a
            href={bookHref}
            className="group inline-flex h-14 items-center justify-center gap-2 rounded-md bg-accent px-8 font-display tracking-wider text-accent-foreground hover:bg-accent/90"
          >
            {bookLabel}{" "}
            <ArrowRight
              className="h-4 w-4 transition-transform group-hover:translate-x-1"
              aria-hidden="true"
            />
          </a>
          <a
            href={`tel:${SITE.phoneTel}`}
            className="inline-flex h-14 items-center justify-center gap-2 rounded-md border border-primary-foreground/30 px-8 font-display tracking-wider text-primary-foreground hover:border-accent hover:text-accent"
          >
            <Phone className="h-4 w-4" aria-hidden="true" /> {SITE.phoneDisplay}
          </a>
        </div>
      </div>
    </section>
  );
}
